import * as Sentry from '@sentry/vue';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import { createApp } from 'vue';

import { applyPolyfills, defineCustomElements } from '@emobg/web-components/loader';
import { ENV } from '@emobg/web-utils';

import App from './App.vue';
import { ClickOutside } from './directives/clickOutside.directive';
import { NoClipboard } from './directives/noClipboard.directive';
import { Validate } from './directives/validate.directive';
import router from './router';
import { store } from './store';

const packageVersion = require('../package.json').version;
const LDClientSideID = window.VUE_APP_LAUNCHDARKLY_CLIENT_ID || process.env.VUE_APP_LAUNCHDARKLY_CLIENT_ID;

applyPolyfills().then(() => {
  defineCustomElements();
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://2f591fa72d6e4cb78b8cd7b4ec8a1a35@o274321.ingest.sentry.io/4505232095182848',
  release: packageVersion,
  tracesSampleRate: process.env.NODE_ENV !== ENV.production ? 1.0 : 0.1,
  enabled: process.env.NODE_ENV !== ENV.local,
  environment: window.VUE_APP_SENTRY_ENVIRONMENT_NAME || process.env.VUE_APP_SENTRY_ENVIRONMENT_NAME,
  ignoreErrors: ['Non-Error exception captured'],
});

app
  .use(store)
  .use(router)
  .use(LDPlugin, { clientSideID: LDClientSideID })
  .directive('click-outside', ClickOutside)
  .directive('validate', Validate)
  .directive('no-clipboard', NoClipboard)
  .mount('#app');
